import { useBoToast } from '@invivodf/common/src/application/composables/useBoToast'
import { useRouter } from '@invivodf/common/src/application/composables/useRouter'
import { DiscountRouteName } from '../routes/discountRouteName'
import { deleteDiscount } from '../../dependency-injection'
import { useSeller } from '../../../../application/composables/useSeller'
import { useMetaDiscountFeature } from './useMetaDiscountFeature'

const DELETE_MESSAGE = `La remise a été supprimée avec succès`

export const useDeleteDiscount = (id: string) => {
  const router = useRouter()
  const { showNotificationSuccess, showNotificationError } = useBoToast()
  const seller = useSeller()
  const metaDiscountFeature = useMetaDiscountFeature()

  const usecase = async () => {
    try {
      await deleteDiscount.execute(seller.value.id, id, metaDiscountFeature.isActivated)
      showNotificationSuccess(DELETE_MESSAGE)
      router.replace({ name: DiscountRouteName.LISTING })
    } catch (e) {
      showNotificationError(e.message)
    }
  }

  return {
    deleteDiscount: usecase,
  }
}
